import API from "Connectors/_main";
import {ApplicationStatusResponse} from "API/Info/info.Models";

export const getApplicationStatus = () => {
  return API.get<ApplicationStatusResponse>('/info/application-status')
}



// WEBPACK FOOTER //
// ./src/API/Info/info.Connectors.ts